/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import i18n from "../../../i18n/i18n";
import useAppStore from "../../../store/AppStore";
import { useRoleStore, useUserRoleListState } from "./store/RoleStore";
import { deleteRoleById, getAccessList, getRoleById } from "./core/_request";
import { UserRoleItemType, UserRolePageState } from "./core/_model";
import { ActionsKey } from "../../../common/models/Actions";
import { ColumnItem } from "../../../common/models/table";
import { toast } from "sonner";
import { TitleHeader } from "../../../common/components/TitleHeader/TitleHeader";
import { Loader } from "../../../common/components/Loader/Loader";
import { CustomDrawer } from "../../../common/components/Drawer/CustomDrawer";
import { FormRole } from "./components/FormRole";
import { LFTableV3 } from "../../../common/components/LFTable/LFTableV3";

const cols: ColumnItem[] = [
  {
    key: "name",
    title: "Rôle",
    dataIndex: "name",
    show: true,
  },
];

const RoleList = () => {
  const { activeMenu } = useAppStore();
  const { pageState, setPageState, resetPageState } = useUserRoleListState();
  const { accessList, setAccessList, actioned, setActioned, totalItems } =
    useRoleStore();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isOpenDrawer, setIsOpernDrawer] = useState<boolean>(false);

  useEffect(() => {
    if (!isOpenDrawer) {
      setActioned({ data: null, action: "no" });
    }
  }, [isOpenDrawer]);

  useEffect(() => {
    refreshAccessList(pageState);
  }, [pageState]);

  const handleOpenDrawer = () => {
    setIsOpernDrawer((prev: boolean) => !prev);
  };

  const onDeleteRoleById = async (role: UserRoleItemType) => {
    const deleteResponse = await deleteRoleById(role?.id?.toString());
    if (deleteResponse && deleteResponse?.success) {
      toast.success("Rôle supprimé avec succès");
    } else {
      toast.error("Une erreur de suppresion du rôle");
    }
    refreshAccessList();
  };
  const onActionClick = (role: UserRoleItemType, action: ActionsKey) => {
    if (action === "delete") {
      onDeleteRoleById(role);
    } else {
      handleOpenDrawer();
      setActioned({ data: role, action });
    }
  };
  const refreshAccessList = async (newState?: UserRolePageState) => {
    try {
      setIsLoading(true);
      const list = await getAccessList(newState ?? pageState);
      if (list) {
        setAccessList(list);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSetParams = (params: any) => {
    setPageState({
      ...params,
    });
  };

  const onSuccess = () => {
    handleOpenDrawer();
    refreshAccessList();
  };

  return (
    <div>
      <Loader isLoading={isLoading} />
      <TitleHeader
        title={activeMenu?.title ?? ""}
        isEnableAdd
        onClickOnAdd={handleOpenDrawer}
      />

      <div className="py-4">
        <LFTableV3
          columns={cols}
          data={accessList?.member as any}
          params={pageState}
          onAction={onActionClick}
          isCanDelete={(row: any) => !row?.isRequired}
          isCanEdit={(row: any) => !row?.isRequired}
          isCanShow={(row: any) => !row?.isRequired}
          onSearch={handleSetParams}
          onSort={handleSetParams}
          onResetSearch={resetPageState}
          onChangePage={handleSetParams}
          pagination={{
            defaultCurrentPage: pageState.page,
            itemsPerPage: pageState?.itemsPerPage,
            totalItems: totalItems,
          }}
        />
      </div>

      {isOpenDrawer && (
        <CustomDrawer
          title={
            actioned?.action === "read"
              ? "Détails"
              : actioned?.action === "update"
              ? "Modification"
              : i18n.t("NEW")
          }
          isOpen={isOpenDrawer}
          onClose={handleOpenDrawer}
        >
          <FormRole
            onSuccess={onSuccess}
            {...(actioned?.action === "read" || actioned?.action === "update"
              ? {
                  initialValue: actioned.data,
                  type: actioned.action,
                }
              : {})}
          />
        </CustomDrawer>
      )}
    </div>
  );
};

export default RoleList;
